import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import type { Address, LatLng } from '@/api/place/types';

export const useCurrentLocationStore = create(
  devtools(
    combine(
      {
        loading: true as boolean,
        coords: null as LatLng | null,
        currentAddress: null as Address | null,
      },
      (set) => ({
        setDetectingLocation: (loading: boolean) => {
          set({ loading });
        },
        setCoords: (coords: LatLng) => {
          set({ coords });
        },
        setCurrentAddress: (currentAddress: Address | null) => {
          // const currentCoords = get().coords;
          if (currentAddress) {
            set({
              coords: { lat: currentAddress.lat, lng: currentAddress.lng },
            });
          }
          set({ currentAddress });
        },
      })
    )
  )
);
